var _path;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgRupay(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 17,
    height: 29,
    viewBox: "0 0 17 29",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M12.8027 3.3926C13.2929 4.1893 13.6288 5.17189 13.8103 6.34038H16.3974V9.52717H13.9465C13.8194 11.4392 13.3383 13.0194 12.5032 14.2675C11.6862 15.5157 10.606 16.3257 9.2626 16.6974C9.80724 16.8833 10.2974 17.2153 10.7331 17.6933C11.1688 18.1713 11.5773 18.8485 11.9586 19.7249L16.0161 28.5682H11.8224L7.73762 19.5257C7.37453 18.6759 6.9842 18.0784 6.56665 17.7332C6.16725 17.3614 5.63169 17.1755 4.95997 17.1755H1.03857V13.1521H6.83897C7.89193 13.1521 8.72704 12.8467 9.3443 12.2359C9.96155 11.6251 10.3428 10.7222 10.488 9.52717H1.03857V6.34038H10.3791C10.1794 5.35779 9.78001 4.62748 9.18091 4.14946C8.58181 3.64489 7.80116 3.3926 6.83897 3.3926H1.03857V0.205811H16.3974V3.3926H12.8027Z",
    fill: "white",
    stroke: "white",
    strokeWidth: 0.4
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgRupay);
export default __webpack_public_path__ + "static/media/rupay.5b03a641af21de0bcdbf1b22f68d14f6.svg";
export { ForwardRef as ReactComponent };